import { render, staticRenderFns } from "./StickyBottomSaveContent.vue?vue&type=template&id=6e9c44f3&scoped=true&lang=pug&"
import script from "./StickyBottomSaveContent.vue?vue&type=script&lang=js&"
export * from "./StickyBottomSaveContent.vue?vue&type=script&lang=js&"
import style0 from "./StickyBottomSaveContent.vue?vue&type=style&index=0&id=6e9c44f3&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c44f3",
  null
  
)

/* custom blocks */
import block0 from "@/lang/components/stickyBottomSaveContent.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fsrc%2Fcomponents%2FStickyBottomSaveContent.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports